/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AvailableCompanyForLinking
 */
export interface AvailableCompanyForLinking {
  /**
   *
   * @type {string}
   * @memberof AvailableCompanyForLinking
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof AvailableCompanyForLinking
   */
  companyName: string;
}

/**
 * Check if a given object implements the AvailableCompanyForLinking interface.
 */
export function instanceOfAvailableCompanyForLinking(
  value: object,
): value is AvailableCompanyForLinking {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  return true;
}

export function AvailableCompanyForLinkingFromJSON(
  json: any,
): AvailableCompanyForLinking {
  return AvailableCompanyForLinkingFromJSONTyped(json, false);
}

export function AvailableCompanyForLinkingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AvailableCompanyForLinking {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyName: json["companyName"],
  };
}

export function AvailableCompanyForLinkingToJSON(
  json: any,
): AvailableCompanyForLinking {
  return AvailableCompanyForLinkingToJSONTyped(json, false);
}

export function AvailableCompanyForLinkingToJSONTyped(
  value?: AvailableCompanyForLinking | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyName: value["companyName"],
  };
}
